import type { Evidence } from 'api';

export const formatSampleEvidence = (evidenceList: Evidence[]) => {
  return evidenceList.map((evidence) => ({
    annotations: evidence.model_results?.coco_prediction ? [...evidence.model_results.coco_prediction] : [],
    file: evidence.file,
    preview: evidence.preview,
  }));
};
